module.exports = __webpack_public_path__ + "img/eq-laying-of-hands.2e2d01d4.png";